import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const token = localStorage.getItem('accessToken');

    if (token) {
      // Allow access to SSO login route even with token if we're processing SSO
      // This prevents redirect loops during SSO flow
      const isSsoLoginRoute = route.routeConfig?.path === 'sso-login';
      const isProcessingSso = sessionStorage.getItem('ssoInvitationCode') || 
                             sessionStorage.getItem('ssoInvitationEmail') ||
                             sessionStorage.getItem('ssoReturnUrl');
      
      // If we're on SSO login route and processing SSO, allow access
      // The SSO component will handle navigation after token is stored
      if (isSsoLoginRoute && isProcessingSso) {
        return true;
      }

      // For other routes or if not processing SSO, redirect to dashboard
      return this.router.createUrlTree(['/main/home/dashboard']);
    }

    return true;
  }
}
